<template>
  <div v-if="dataReady" class="content">
    <div class="order-sticky-scroll">
      <Navi class="order-sticky" tab-id="3" :form="form" mode="default" />

      <h2 class="page-title">発注内容確認</h2>
      <form class="section-wrapper">
        <confirm-detail v-for="(form, i) in formList" :form="form" :key="i" />

        <h4 class="page-sub-title pl-2 pl-md-4 mt-5">オプション</h4>
        <section id="history-detail-option">
          <div class="section-child">
            <table v-if="isMeihen" class="table">
              <tr>
                <th><span>土曜日納車</span></th>
                <td>
                  <span v-if="isNosyaSaturday">選択されています</span>
                </td>
              </tr>
            </table>

            <table v-if="option.ETC_SETUP_FLG !== undefined" class="table">
              <tr>
                <th><span>ETC車載器セットアップのご希望</span></th>
                <td>
                  <span>
                    {{ getText(etcHopeList, Number(option.ETC_SETUP_FLG)) }}
                  </span>
                </td>
              </tr>
              <tr v-if="option.ETC_KANRI_BANGO !== undefined">
                <th><span>ETC車載器管理番号</span></th>
                <td>
                  <span>{{ option.ETC_KANRI_BANGO }}</span>
                </td>
              </tr>
              <tr v-if="option.ETC_TOUROKU_BANGO !== undefined">
                <th><span>ETC型式登録番号</span></th>
                <td>
                  <span>{{ option.ETC_TOUROKU_BANGO }}</span>
                </td>
              </tr>
            </table>

            <table
              v-if="option.SYAKOSYO_JYURYO_FLG !== undefined"
              class="table mt-2"
            >
              <tr>
                <th><span>車庫証明申請受領のご希望</span></th>
                <td>
                  <span>
                    {{
                      getText(yesNoHopeList, Number(option.SYAKOSYO_JYURYO_FLG))
                    }}
                  </span>
                </td>
              </tr>
              <tr v-if="option.SYAKOSYO_JYURYO_KBN !== undefined">
                <th><span>車庫証明申請書類</span></th>
                <td>
                  <span v-if="form.MEIHEN_FLG && isLease">
                    {{
                      getText(
                        syakosyoJyuryoKbn,
                        Number(option.SYAKOSYO_JYURYO_KBN)
                      ).replace('ユーザー', '使用者')
                    }}
                  </span>
                  <span v-else>
                    {{
                      getText(
                        syakosyoJyuryoKbn,
                        Number(option.SYAKOSYO_JYURYO_KBN)
                      )
                    }}
                  </span>
                </td>
              </tr>
            </table>

            <table v-if="option.SEISOU_FLG !== undefined" class="table mt-2">
              <tr>
                <th><span>清掃サービス</span></th>
                <td>
                  <span>
                    {{ getText(yesNoHopeList, Number(option.SEISOU_FLG)) }}
                  </span>
                </td>
              </tr>
              <tr v-if="option.SEISOU_KBN !== undefined">
                <th><span>清掃内容</span></th>
                <td>
                  <span>
                    {{ getText(seisoList, Number(option.SEISOU_KBN)) }}
                  </span>
                </td>
              </tr>
            </table>

            <table v-if="option.HOKAN_FLG !== undefined" class="table mt-2">
              <tr>
                <th><span>保管のご希望</span></th>
                <td>
                  <span>{{ getText(yesNoHopeList, option.HOKAN_FLG) }}</span>
                </td>
              </tr>
            </table>

            <table
              v-if="option.SYAKO_SYODAKUSYO_FLG !== undefined"
              class="table mt-2"
            >
              <tr>
                <th><span>車庫承諾書取得のご希望</span></th>
                <td>
                  <span>
                    {{ getText(yesNoIraiList, option.SYAKO_SYODAKUSYO_FLG) }}
                  </span>
                </td>
              </tr>
              <tr v-if="option.SYAKO_SYODAKUSYO_TORIYOSE_FLG !== undefined">
                <th><span>承諾書の取寄せ先</span></th>
                <td>
                  <span>
                    {{
                      getText(
                        syakoSyodakusyoToriyoseList,
                        option.SYAKO_SYODAKUSYO_TORIYOSE_FLG
                      )
                    }}
                  </span>
                </td>
              </tr>
              <tr
                v-if="
                  option.SYAKO_SYODAKUSYO_CHUSYAJYO_KEIYAKU_MEI !== undefined
                "
              >
                <th><span>契約者名</span></th>
                <td>
                  <span>
                    {{ option.SYAKO_SYODAKUSYO_CHUSYAJYO_KEIYAKU_MEI }}
                  </span>
                </td>
              </tr>
              <tr v-if="option.SYAKO_SYODAKUSYO_CHUSYAJYO_MEI !== undefined">
                <th><span>駐車場名</span></th>
                <td>
                  <span>{{ option.SYAKO_SYODAKUSYO_CHUSYAJYO_MEI }}</span>
                </td>
              </tr>
              <tr v-if="option.SYAKO_SYODAKUSYO_CHUSYAJYO_BANGO !== undefined">
                <th><span>駐車場番号</span></th>
                <td>
                  <span>{{ option.SYAKO_SYODAKUSYO_CHUSYAJYO_BANGO }}</span>
                </td>
              </tr>
              <tr v-if="option.SYAKO_SYODAKUSYO_YUBIN1 !== undefined">
                <th><span>住所</span></th>
                <td>
                  <span
                    v-if="
                      option.SYAKO_SYODAKUSYO_YUBIN1 &&
                      option.SYAKO_SYODAKUSYO_YUBIN2
                    "
                  >
                    {{ option.SYAKO_SYODAKUSYO_YUBIN1 }}-{{
                      option.SYAKO_SYODAKUSYO_YUBIN2
                    }}
                    <br />
                  </span>
                  <span v-if="option.SYAKO_SYODAKUSYO_TODO_MEI">
                    {{ option.SYAKO_SYODAKUSYO_TODO_MEI }}
                  </span>
                  <span v-if="option.SYAKO_SYODAKUSYO_SHIKU_MEI">
                    {{ option.SYAKO_SYODAKUSYO_SHIKU_MEI }}
                  </span>
                  <span v-if="option.SYAKO_SYODAKUSYO_BANCHI">
                    {{ option.SYAKO_SYODAKUSYO_BANCHI }}
                  </span>
                </td>
              </tr>
              <tr v-if="option.SYAKO_SYODAKUSYO_TEL !== undefined">
                <th><span>TEL</span></th>
                <td>
                  <span>{{ option.SYAKO_SYODAKUSYO_TEL }}</span>
                </td>
              </tr>
              <tr v-if="option.SYAKO_SYODAKUSYO_TORIYOSE !== undefined">
                <th><span>取寄せ先情報</span></th>
                <td>
                  <span>{{ option.SYAKO_SYODAKUSYO_TORIYOSE }}</span>
                </td>
              </tr>
            </table>

            <table
              v-if="option.JYUMINHYO_DAIKO_FLG !== undefined"
              class="table mt-2"
            >
              <tr>
                <th><span>住民票取得代行のご希望</span></th>
                <td>
                  <span>
                    {{ getText(yesNoHopeList, option.JYUMINHYO_DAIKO_FLG) }}
                  </span>
                </td>
              </tr>
              <tr v-if="option.JYUMINHYO_DAIKO_YEAR !== undefined">
                <th><span>生年月日</span></th>
                <td>
                  <span v-if="option.JYUMINHYO_DAIKO_YEAR">
                    {{
                      `${option.JYUMINHYO_DAIKO_YEAR}年${option.JYUMINHYO_DAIKO_MONTH}月${option.JYUMINHYO_DAIKO_DAY}日`
                    }}
                  </span>
                </td>
              </tr>
              <tr v-if="option.JYUMINHYO_FLG !== undefined">
                <th>
                  <span>住民票と登録地が異なりますか？</span>
                </th>
                <td>
                  <span>
                    {{ getText(yesNoFumeiList, option.JYUMINHYO_FLG) }}
                  </span>
                </td>
              </tr>
              <tr v-if="option.JYUMINHYO_YUBIN1 !== undefined">
                <th><span>住所</span></th>
                <td>
                  <span
                    v-if="option.JYUMINHYO_YUBIN1 && option.JYUMINHYO_YUBIN2"
                  >
                    {{ option.JYUMINHYO_YUBIN1 }}-{{ option.JYUMINHYO_YUBIN2 }}
                    <br />
                  </span>
                  <span>
                    {{ option.JYUMINHYO_TODO_MEI
                    }}{{ option.JYUMINHYO_SHIKU_MEI
                    }}{{ option.JYUMINHYO_BANCHI }}
                  </span>
                </td>
              </tr>
            </table>

            <table
              v-if="option.SYAKENSYO_SAIHAKKO_FLG !== undefined"
              class="table mt-2"
            >
              <tr>
                <th><span>車検証再発行のご希望</span></th>
                <td>
                  <span>
                    {{ getText(yesNoHopeList, option.SYAKENSYO_SAIHAKKO_FLG) }}
                  </span>
                </td>
              </tr>
            </table>

            <table v-if="option.YOUBOU !== undefined" class="table mt-2">
              <tr>
                <th><span>その他ご要望</span></th>
                <td>
                  <span>{{ option.YOUBOU }}</span>
                </td>
              </tr>
            </table>
          </div>
        </section>

        <div v-if="isEnableInvoice">
          <h4 class="page-sub-title pl-2 pl-md-4 mt-5">請求先</h4>
          <section id="history-detail-seikyu">
            <div class="section-child">
              <table v-if="!Number(form.SKS_DIRECT_FLG)" class="table">
                <tr>
                  <th><span>請求先</span></th>
                  <td><span>貴社宛</span></td>
                </tr>
              </table>
              <table v-else class="table">
                <tr>
                  <th><span>会社名</span></th>
                  <td>
                    <span>{{ form.SKS_KAISYA }}</span>
                  </td>
                </tr>
                <tr>
                  <th><span>担当部署</span></th>
                  <td>
                    <span>{{ form.SKS_BUSYO }}</span>
                  </td>
                </tr>
                <tr>
                  <th><span>住所</span></th>
                  <td>
                    <span v-if="form.SKS_YUBIN1 && form.SKS_YUBIN2">
                      {{ form.SKS_YUBIN1 }}-{{ form.SKS_YUBIN2 }}
                      <br />
                    </span>
                    <span>
                      {{ form.SKS_TODO }}{{ form.SKS_SHIKU_MEI
                      }}{{ form.SKS_JYUSYO1 }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <th><span>担当者</span></th>
                  <td>
                    <span>{{ form.SKS_TANTO_MEI }}</span>
                  </td>
                </tr>
                <tr>
                  <th><span>TEL</span></th>
                  <td>
                    <span>{{ form.SKS_TEL }}</span>
                  </td>
                </tr>
                <tr v-if="form.SKS_IS_FAVORITE_SAVE !== undefined">
                  <th><span>お気に入りに保存する</span></th>
                  <td>
                    <span>
                      {{
                        Number(form.SKS_IS_FAVORITE_SAVE)
                          ? '保存する'
                          : '保存しない'
                      }}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </section>
        </div>

        <section class="mt-2 p-2 p-sm-3 mx-2 apply-consent">
          <div class="text-left underline ml-lg-5">
            <span>
              車両の申告内容に相違がある場合は輸送料金が変動する可能性があります。
            </span>
          </div>
          <div class="my-md-2">
            <div class="mt-1 mt-md-3 check-box-wrapper">
              <label class="col-md-4 pt-md-2 bold pc-fs-20" />
              <md-checkbox
                :class="[
                  'form-check-input md-primary col-md-3',
                  { 'pos-relative': isMS },
                ]"
                v-model="consents"
                value="1"
              >
                <strong class="f-size-18">同意する</strong>
              </md-checkbox>
            </div>
          </div>
        </section>

        <section class="mt-2 p-2 p-sm-3 mx-2 apply-consent">
          <div class="text-left underline ml-lg-5">
            <span>
              取引の申し込みにあたり、弊社「
              <a
                href="https://www.logi-co.co.jp/service/rules.pdf"
                target="_blank"
              >
                輸送規約
              </a>
              」のご確認、ご同意が必要となります。
            </span>
            <br />
            <span>
              上記の内容をご確認のうえ、ご同意いただける場合はチェックボックスにチェックを入れお申し込みください。
            </span>
          </div>
          <div class="my-md-3">
            <div class="mt-1 mt-md-3 check-box-wrapper">
              <label class="col-md-4 pt-md-2 bold pc-fs-20">
                輸送規約・免責事項
              </label>
              <md-checkbox
                :class="[
                  'form-check-input md-primary col-md-3',
                  { 'pos-relative': isMS },
                ]"
                v-model="consents"
                value="2"
              >
                <strong class="f-size-18">同意する</strong>
              </md-checkbox>
            </div>
          </div>
        </section>

        <div class="text-center mt-md-5 mr-3 mr-md-0">
          <md-button
            type="button"
            class="btn-lg btn-secondary base-btn col-md-3 col-lg-2"
            @click="back"
          >
            もどる
          </md-button>
          <br v-if="isMobile" />
          <md-button
            type="button"
            class="btn-lg btn-success base-btn col-md-3 col-lg-2 md-raised"
            @click="post"
            :disabled="consents.length !== 2"
          >
            発注
          </md-button>
        </div>
      </form>
    </div>

    <md-dialog-confirm
      class="new pink"
      :md-fullscreen="false"
      :md-active.sync="isErrModal"
      md-title=""
      :md-content="errMessage"
      md-confirm-text="問い合わせる"
      md-cancel-text="キャンセル"
      :md-click-outside-to-close="false"
      @md-confirm="gotoInquiry"
    />

    <md-snackbar
      :class="snackbarClass"
      md-position="center"
      :md-active.sync="isSnackbar"
      md-persistent
    >
      <span>{{ snackbarText }}</span>
    </md-snackbar>

    <inquiry-dialog
      :jyuchu-syaryo-id="inquiry.jyuchuSyaryoId"
      :is-showing-inquiry-dialog-confirm.sync="inquiry.isShowing"
      :hikitori-yotei-bi="inquiry.hikitoriYoteiBi"
    />
  </div>
</template>

<script>
import orderApi from '@/api/order'
import ConfirmDetail from '@/components/order/ConfirmDetail'
import InquiryDialog from '@/components/order/InquiryDialog'
import Constant from '@/const'
import Store from '@/store/index.js'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import Mixin from '../mixin/Mixin'
import Navi from './Navi'

const OPTION_KBN = {
  ETC: '01', // ETCセットアップ
  SYAKO: '02', // 車庫証明
  SYAKO_KEI: '03', // 車庫証明（軽自動車）
  KIBOU_NUM: '04', // 希望ナンバー
  SATURDAY: '05', // 土曜日輸送
}

export default {
  name: 'Confirm',
  components: {
    ConfirmDetail,
    Navi,
    InquiryDialog,
  },
  mixins: [Mixin],
  data: () => ({
    /** 見積から発注したフラグ */
    isMitumori: false,

    /** 見積データ */
    mitumori: null,

    /** スナックバー表示フラグ */
    isSnackbar: false,

    /**スナックバークラス */
    snackbarClass: 'bg-danger',

    /** スナックバーテキスト */
    snackbarText: null,

    /** 入力データリスト */
    formList: [],

    /** オプションデータ */
    optionList: [],

    hansyutukens: [],
    errMessage: '',
    consents: [],
    clonedForm: {},
    isErrModal: false,
    form: {},
    dataReady: false,

    isUpdatable: true,
    inquiry: {
      jyuchuSyaryoId: null,
      hikitoriYoteiBi: null,
      isShowing: false,
    },
  }),

  async created() {
    if (!this.$route.params.form) {
      return this.$router.push({ name: 'OrderIndex' })
    }
    this.spinerOn()
    this.form = this.$route.params.form

    const [_, isUpdatable] = await this.fetchData()
    if (isUpdatable === false) {
      this.isUpdatable = false
      this.inquire()
    }

    this.setHanshutukens()
    this.clonedForm = cloneDeep(this.form)

    if (this.form.mitumori) {
      this.mitumori = cloneDeep(this.form.mitumori)
      delete this.form.mitumori
    }

    // 車両のオプションは共通
    this.option = this.form.option

    const irekaeFormList = this.form.syaryos
      .filter((v) => v.irekae)
      .map((v, i) => {
        let arr = []
        if (v.SYADAI_BANGO) arr.push(v.SYADAI_BANGO)
        if (v.TOUROKU_BANGO) arr.push(v.TOUROKU_BANGO.replace(/ /g, '-'))
        v.irekae.syaryo.IREKAE_SYARYO = `${v.SYARYO_MEI}（${arr.join('/')}）`
        v.irekaemotoId = i
        v.irekae.isIrekae = true
        v.irekae.syaryo.irekaechildId = i
        v.irekae.syaryos = [v.irekae.syaryo]
        return v.irekae
      })
    await this.addFormList()
    for (const form of irekaeFormList) {
      this.form = form
      await this.addFormList()
    }
    this.scroll('clear')
    this.spinerOff()
    this.dataReady = true
  },

  methods: {
    fetchData() {
      const promises = [this.getOption()]

      if (this.form.isFromHistoryEdit) {
        const isUpdatablePromise = orderApi.getIsUpdatable(
          this.form.syaryos[0].ID
        )
        promises.push(isUpdatablePromise)
      }

      return Promise.all(promises)
    },
    setHanshutukens() {
      for (const syaryo of this.form.syaryos) {
        this.hansyutukens.push(syaryo.HANSYUTUKEN)
      }
    },
    reverseHanshutukens() {
      for (const i in this.clonedForm.syaryos) {
        this.clonedForm.syaryos[i].HANSYUTUKEN = this.hansyutukens[i]
      }
    },
    // 戻る
    back() {
      this.reverseHanshutukens()
      const params = {
        form: this.clonedForm,
      }
      this.$router.push({
        name: this.form.MEIHEN_FLG ? 'OrderMeihenVehicle' : 'OrderVehicle',
        params,
      })
    },
    /**
     * フォームPOST
     */
    post() {
      if (!this.isUpdatable) {
        this.inquire()
        return
      }

      this.spinerOn()

      // データ登録API
      this.$store
        .dispatch('order/setJyucyu', this.formList)
        .then((res) => {
          if (this.isMitumori) {
            this.addRireki()
            this.updateMitumori()
          }
          this.scroll('clear')
          this.spinerOff()
          this.$router.push({ name: 'OrderComplete' })
        })
        .catch((err) => {
          this.errMessage = this.getHcbApiErrorMessage(err.message)
          this.consents = []
          this.isErrModal = true
          this.scroll('clear')
          this.spinerOff()
        })
    },

    /** 履歴データを登録する */
    addRireki() {
      const data = {
        MITUMORI_ID: this.mitumori.ID,
        NAIYOU: `ステータス: ${this.getText(
          this.statusList,
          Constant.status.jyucyu
        )}`,
      }
      this.addMitumoriRireki(data).catch((err) => {
        this.snackbarText = 'エラーが発生しました code: 502'
        this.snackbarClass = 'bg-danger'
        this.isSnackbar = true
      })
    },

    /** 見積更新 */
    updateMitumori() {
      const data = { ID: this.mitumori.ID, STATUS: Constant.status.jyucyu }
      return Store.dispatch('mitumori/edit', data).catch((err) => {
        this.snackbarText = 'エラーが発生しました code: 503'
        this.snackbarClass = 'bg-danger'
      })
    },

    /** 不要データを削除する */
    cleanup() {
      delete this.form.syaryo
      delete this.form.option
      delete this.form.TABLE_LIST
      delete this.form.HIKITORI_AUCTION
      delete this.form.HIKITORI_MASTER
      delete this.form.HIKITORI_DIRECT
      delete this.form.HIKITORI_FAVORITE
      delete this.form.NOSYA_AUCTION
      delete this.form.NOSYA_MASTER
      delete this.form.NOSYA_DIRECT
      delete this.form.NOSYA_FAVORITE
      this.form.syaryos.map((v) => {
        delete v.irekae
        return v
      })
    },

    /** 見積結果を取得する */
    async calc(syaryo) {
      const _this = this

      // APIのリクエストデータを生成
      const makeCalcData = function (syaryo) {
        const getPlaceType = function (hikino) {
          switch (_this.form[`${hikino}_PLACE_TYPE`]) {
            case 'torokubasyo':
              return Constant.RYOKIN_API_AREA_TYPE.TOROKU
            case 'okiniiri':
            case 'direct':
              return Number(_this.form[`${hikino}_AA_FLG`]) === 0
                ? Constant.RYOKIN_API_AREA_TYPE.AREA
                : Constant.RYOKIN_API_AREA_TYPE.AUCTION
          }
        }
        const getPersonal = function (hikino) {
          switch (_this.form[`${hikino}_PLACE_TYPE`]) {
            case 'torokubasyo':
              return 0
            case 'okiniiri':
            case 'direct':
              return Number(_this.form[`${hikino}_AA_FLG`]) === 0
                ? _this.form[`${hikino}_YUSO_KBN`] === Constant.YUSOKBN.KOJIN
                : 0
          }
        }
        const getShikiCd = function (hikino) {
          switch (_this.form[`${hikino}_PLACE_TYPE`]) {
            case 'torokubasyo':
              return null
            case 'okiniiri':
            case 'direct':
              return Number(_this.form[`${hikino}_AA_FLG`]) === 0
                ? _this.form[`${hikino}_SHIKU_CD`]
                : _this.form[`${hikino}_AA_CD`]
          }
        }
        const getTorokubasyo = function (hikino) {
          switch (_this.form[`${hikino}_PLACE_TYPE`]) {
            case 'torokubasyo':
              return _this.form[`${hikino}_PLACE_REF_ID`]
            case 'okiniiri':
            case 'direct':
              null
          }
        }

        return {
          JYUCYU_SHIKI_CD: Store.state.user.data.JYUCYU_SHIKI_CD,
          MEIHEN_FLG: _this.form.MEIHEN_FLG,
          syaryo: syaryo,
          hikitori: {
            PLACE_TYPE: getPlaceType('HIKITORI'),
            IS_PERSONAL: getPersonal('HIKITORI'),
            TOROKUBAYO_KO_ID: getTorokubasyo('HIKITORI'),
            SHIKI_CD: getShikiCd('HIKITORI'),
          },
          nosya: {
            PLACE_TYPE: getPlaceType('NOSYA'),
            IS_PERSONAL: getPersonal('NOSYA'),
            TOROKUBAYO_KO_ID: getTorokubasyo('NOSYA'),
            SHIKI_CD: getShikiCd('NOSYA'),
            HANNYU_KIBOU_BI: _this.form.HANNYU_KIBOU_BI,
          },
        }
      }

      // API実行条件を満たしているか判定
      const isEnableCalc = function (syaryo) {
        const carConditions = syaryo.CAR_CONDITIONS
        return !(
          (syaryo.JISOU_KBN !== undefined && Number(syaryo.JISOU_KBN) !== 1) ||
          Number(syaryo.SYARYO_TYPE_KBN) !== 1 ||
          Number(syaryo.JYOTAI_FLG) ||
          Number(syaryo.HOKAN_FLG) ||
          // 車両状態がデフォルト値から変更あるものは「別途見積」とする
          (carConditions.is_self_run !== undefined &&
            carConditions.is_self_run !== 1) ||
          (carConditions.is_custom !== undefined &&
            carConditions.is_custom !== 0) ||
          (carConditions.is_expensive !== undefined &&
            carConditions.is_expensive !== 0) ||
          (carConditions.is_classic !== undefined &&
            carConditions.is_classic !== 0) ||
          // 電気自動車, 燃料電池, 水素車 は「別途見積」とする
          (carConditions.fuel_type !== undefined &&
            [4, 5, 8].includes(carConditions.fuel_type))
        )
      }

      // API実行
      const noPrice = {
        result_code: 1,
        result_price: 0,
        result_noki: 0,
        isMitumori: false,
      }
      const exec = function (data) {
        return Store.dispatch('mitumori/ryokin', data).catch((err) => {
          //_this.snackbarText = 'エラーが発生しました code: 501'
          //_this.isSnackbar = true
          return noPrice
        })
      }

      /** 見積時と発注時の引納先の値が同じか判定 */
      const isSameMitumoriHikino = (mitumori, hikino) => {
        const f = this.form
        switch (f[`${hikino}_PLACE_TYPE`]) {
          // 登録済みの場所
          case 'torokubasyo':
            return (
              f[`${hikino}_PLACE_REF_ID`] === mitumori[`${hikino}_TOROKU_ID`]
            )

          case 'direct':
          case 'okiniiri':
            // オークション会場
            if (f[`${hikino}_AA_FLG`]) {
              return f[`${hikino}_AA_CD`] === mitumori[`${hikino}_AA_CD`]
              // 直接入力
            } else {
              return (
                f[`${hikino}_TODO_CD`] === mitumori[`${hikino}_TODO_CD`] &&
                f[`${hikino}_SHIKU_CD`] === mitumori[`${hikino}_SHIKU_CD`]
              )
            }

          default:
            return false
        }
      }

      /** 見積時と発注時の車両の値が同じか判定 */
      const isSameMitumoriSyaryo = (syaryo, mitumori) => {
        const isSame = (a, b) => {
          return a === null || a === '' || a === undefined
            ? b === null || b === ''
            : Number(a) === Number(b)
        }

        /** 見積時と発注時で値が異なる項目リスト */
        const isNotSameList = [
          'JYOTAI_FLG',
          'JISOU_KBN',
          'ETC_SETUP_FLG',
          'MEIHEN_KIBO_NUMBER_FLG',
          'MEIHEN_KIBO_NUMBER_DAIKO_FLG',
          'SYAKOSYO_JYURYO_FLG',
          'SYARYO_TYPE_KBN',
          'HOKAN_FLG',
          'MEIHEN_KEI_FLG',
        ].filter((name) => !isSame(syaryo[name], mitumori[name]))
        return isNotSameList.length === 0
      }

      // 見積から発注した車両の場合
      if (syaryo.isMitumori) {
        const m = this.mitumori
        const today = moment()
        const limit = moment(m.LIMITED_NICHIJI.slice(0, 10))
        if (
          today.isSameOrBefore(limit) &&
          isSameMitumoriHikino(m, 'HIKITORI') &&
          isSameMitumoriHikino(m, 'NOSYA') &&
          isSameMitumoriSyaryo(syaryo, m)
        ) {
          this.isMitumori = true

          let uchiwakeTotal = 0
          let uchiwake = m.uchiwake.map((v) => {
            uchiwakeTotal += v.UCHIWAKE_PRICE
            return {
              name: v.UCHIWAKE_NAME,
              price: v.UCHIWAKE_PRICE,
            }
          })

          // 見積料金と内訳料金の総和が違う場合は、見積料金が調整されているため内訳料金を表示させない
          const isAdjustment = m.RYOKIN !== uchiwakeTotal

          // 土曜納車料金
          if (this.isMeihen && this.isNosyaSaturday) {
            const option = this.optionList.find(
              (v) => v.OPTION_KBN === OPTION_KBN.SATURDAY
            )
            this.mitumori.RYOKIN += Number(option.OPTION_PRICE)
            uchiwake.push({
              name: option.OPTION_MEI,
              price: option.OPTION_PRICE,
            })
          }

          return {
            result_code: 0,
            result_price: m.RYOKIN,
            result_noki: m.NOUKI,
            result_uchiwake: uchiwake,
            isMitumori: true,
            isAdjustment: isAdjustment,
          }
        }
      }

      // 料金を計算
      let result = noPrice
      if (isEnableCalc(syaryo)) {
        result = await exec(makeCalcData(syaryo))
        if (Number(result.result_noki)) result.result_noki += '日'
      }

      return result
    },

    /** 登録データを生成する */
    async addFormList() {
      // 引取
      let hActiveName = this.form.ACTIVE_HIKITORI_TAB
      if (hActiveName === 'DIRECT' && this.form.HIKITORI_AA_FLG)
        hActiveName = 'AUCTION'
      this.form.HIKITORI_MEI = this.form[`HIKITORI_${hActiveName}`].MEI
      this.form.HIKITORI_TODO_CD = this.form[`HIKITORI_${hActiveName}`].TODO_CD
      this.form.HIKITORI_TODO_MEI =
        this.form[`HIKITORI_${hActiveName}`].TODO_MEI
      this.form.HIKITORI_SHIKU_CD =
        this.form[`HIKITORI_${hActiveName}`].SHIKU_CD
      this.form.HIKITORI_SHIKU_MEI =
        this.form[`HIKITORI_${hActiveName}`].SHIKU_MEI
      this.form.HIKITORI_BANCHI = this.form[`HIKITORI_${hActiveName}`].BANCHI
      this.form.HIKITORI_TEL = this.form[`HIKITORI_${hActiveName}`].TEL
      this.form.HIKITORI_FAX = this.form[`HIKITORI_${hActiveName}`].FAX
      this.form.HIKITORI_YUBIN1 = this.form[`HIKITORI_${hActiveName}`].YUBIN1
      this.form.HIKITORI_YUBIN2 = this.form[`HIKITORI_${hActiveName}`].YUBIN2
      this.form.HIKITORI_AA_FLG = this.form.HIKITORI_AA_FLG
      this.form.HIKITORI_AA_ID = this.form[`HIKITORI_${hActiveName}`].AA_ID
      this.form.HIKITORI_AA_CD = this.form[`HIKITORI_${hActiveName}`].AA_CD
      this.form.HIKITORI_EIGYO_KAISI_JIKAN =
        this.form[`HIKITORI_${hActiveName}`].EIGYO_KAISI_JIKAN
      this.form.HIKITORI_EIGYO_SYURYO_JIKAN =
        this.form[`HIKITORI_${hActiveName}`].EIGYO_SYURYO_JIKAN
      this.form.HIKITORI_TANTO_MEI =
        this.form[`HIKITORI_${hActiveName}`].TANTO_MEI
      this.form.HIKITORI_TANTO_TEL =
        this.form[`HIKITORI_${hActiveName}`].TANTO_TEL
      this.form.HIKITORI_TANTO_FAX =
        this.form[`HIKITORI_${hActiveName}`].TANTO_FAX
      this.form.HIKITORI_TEIKYU_BI = Array.isArray(
        this.form[`HIKITORI_${hActiveName}`].TEIKYU_BI
      )
        ? this.form[`HIKITORI_${hActiveName}`].TEIKYU_BI.join(',')
        : this.form[`HIKITORI_${hActiveName}`].TEIKYU_BI
      this.form.HIKITORI_YUSO_KBN =
        this.form[`HIKITORI_${hActiveName}`].YUSO_KBN
      this.form.HIKITORI_HCB_ZOKUSEI_CD =
        this.form[`HIKITORI_${hActiveName}`].HCB_ZOKUSEI_CD
      this.form.HIKITORI_LANDMARK_KBN =
        this.form[`HIKITORI_${hActiveName}`].LANDMARK_KBN

      if (hActiveName === 'FAVORITE') {
        this.form.HIKITORI_PLACE_TYPE = 'okiniiri'
        this.form.HIKITORI_PLACE_REF_ID =
          this.form[`HIKITORI_${hActiveName}`].FAVORITE_ID
      } else if (hActiveName === 'MASTER') {
        this.form.HIKITORI_PLACE_TYPE = 'torokubasyo'
        this.form.HIKITORI_HANNYUSYUTU_JIKAN =
          this.form[`HIKITORI_${hActiveName}`].HANNYUSYUTU_JIKAN
        this.form.HIKITORI_PLACE_REF_ID =
          this.form[`HIKITORI_${hActiveName}`].TOROKUBAYO_KO_ID
      } else if (hActiveName === 'DIRECT' || hActiveName === 'AUCTION') {
        this.form.HIKITORI_PLACE_TYPE = 'direct'
        this.form.HIKITORI_OKINIIRI_FLG = this.form.isHikitoriOkiniiri
        this.form.HIKITORI_PLACE_REF_ID =
          this.form[`HIKITORI_${hActiveName}`].AA_ID
      }

      // 納車
      let nActiveName = this.form.ACTIVE_NOSYA_TAB
      if (nActiveName === 'DIRECT' && this.form.NOSYA_AA_FLG)
        nActiveName = 'AUCTION'
      this.form.NOSYA_MEI = this.form[`NOSYA_${nActiveName}`].MEI
      this.form.NOSYA_TODO_CD = this.form[`NOSYA_${nActiveName}`].TODO_CD
      this.form.NOSYA_TODO_MEI = this.form[`NOSYA_${nActiveName}`].TODO_MEI
      this.form.NOSYA_SHIKU_CD = this.form[`NOSYA_${nActiveName}`].SHIKU_CD
      this.form.NOSYA_SHIKU_MEI = this.form[`NOSYA_${nActiveName}`].SHIKU_MEI
      this.form.NOSYA_BANCHI = this.form[`NOSYA_${nActiveName}`].BANCHI
      this.form.NOSYA_TEL = this.form[`NOSYA_${nActiveName}`].TEL
      this.form.NOSYA_FAX = this.form[`NOSYA_${nActiveName}`].FAX
      this.form.NOSYA_YUBIN1 = this.form[`NOSYA_${nActiveName}`].YUBIN1
      this.form.NOSYA_YUBIN2 = this.form[`NOSYA_${nActiveName}`].YUBIN2
      this.form.NOSYA_AA_FLG = this.form.NOSYA_AA_FLG
      this.form.NOSYA_AA_ID = this.form[`NOSYA_${nActiveName}`].AA_ID
      this.form.NOSYA_AA_CD = this.form[`NOSYA_${nActiveName}`].AA_CD
      this.form.NOSYA_EIGYO_KAISI_JIKAN =
        this.form[`NOSYA_${nActiveName}`].EIGYO_KAISI_JIKAN
      this.form.NOSYA_EIGYO_SYURYO_JIKAN =
        this.form[`NOSYA_${nActiveName}`].EIGYO_SYURYO_JIKAN
      this.form.NOSYA_TANTO_MEI = this.form[`NOSYA_${nActiveName}`].TANTO_MEI
      this.form.NOSYA_TANTO_TEL = this.form[`NOSYA_${nActiveName}`].TANTO_TEL
      this.form.NOSYA_TANTO_FAX = this.form[`NOSYA_${nActiveName}`].TANTO_FAX
      this.form.NOSYA_TEIKYU_BI = Array.isArray(
        this.form[`NOSYA_${nActiveName}`].TEIKYU_BI
      )
        ? this.form[`NOSYA_${nActiveName}`].TEIKYU_BI.join(',')
        : this.form[`NOSYA_${nActiveName}`].TEIKYU_BI
      this.form.NOSYA_YUSO_KBN = this.form[`NOSYA_${nActiveName}`].YUSO_KBN
      this.form.NOSYA_HCB_ZOKUSEI_CD =
        this.form[`NOSYA_${nActiveName}`].HCB_ZOKUSEI_CD
      this.form.NOSYA_LANDMARK_KBN =
        this.form[`NOSYA_${nActiveName}`].LANDMARK_KBN
      if (nActiveName === 'FAVORITE') {
        this.form.NOSYA_PLACE_TYPE = 'okiniiri'
        this.form.NOSYA_PLACE_REF_ID =
          this.form[`NOSYA_${nActiveName}`].FAVORITE_ID
      } else if (nActiveName === 'MASTER') {
        this.form.NOSYA_PLACE_TYPE = 'torokubasyo'
        this.form.NOSYA_HANNYUSYUTU_JIKAN =
          this.form[`NOSYA_${nActiveName}`].HANNYUSYUTU_JIKAN
        this.form.NOSYA_PLACE_REF_ID =
          this.form[`NOSYA_${nActiveName}`].TOROKUBAYO_KO_ID
      } else if (nActiveName === 'DIRECT' || nActiveName === 'AUCTION') {
        this.form.NOSYA_PLACE_TYPE = 'direct'
        this.form.NOSYA_OKINIIRI_FLG = this.form.isNosyaOkiniiri
        this.form.NOSYA_PLACE_REF_ID = this.form[`NOSYA_${nActiveName}`].AA_ID
      }

      if (!this.form.HIKITORI_IS_MASTER_ACTIVE && this.form.HIKITORI_TEIKYU_BI)
        this.form.HIKITORI_TEIKYU_BI = this.sortStrWeek(
          this.form.HIKITORI_TEIKYU_BI
        )
      if (!this.form.NOSYA_IS_MASTER_ACTIVE && this.form.NOSYA_TEIKYU_BI)
        this.form.NOSYA_TEIKYU_BI = this.sortStrWeek(this.form.NOSYA_TEIKYU_BI)
      this.cleanup()

      this.form.isHikitoriAA = this.isHikitoriAA
      this.form.isNosyaAA = this.isNosyaAA

      const cloneSyaryos = cloneDeep(this.form.syaryos)
      let syaryos = []
      for (const i in cloneSyaryos) {
        const syaryo = this.form.syaryos[i]
        // 不正データ暫定対応 TODO
        if (!this.isFailure(syaryo, i, cloneSyaryos)) {
          this.form.syaryos[i].calc = await this.calc(syaryo)
          if (this.form.syaryos[i].OTHER_FILE_LIST !== undefined) {
            this.form.syaryos[i].OTHER_FILE_LIST = this.form.syaryos[
              i
            ].OTHER_FILE_LIST.map((v) => {
              return {
                name: v.name,
                url: v.xhr.response,
              }
            })
          }
          syaryos.push(this.form.syaryos[i])
        }
      }
      this.form.syaryos = syaryos
      this.formList.push(cloneDeep(this.form))
    },

    /**
     * 不正データが存在するか判定 暫定対応
     * 不正データが存在しないよう改修することが必要 @TODO
     * @param  object  syaryo
     * @param  int  index
     * @param object cloneSyaryos
     * @return boolean
     */
    isFailure(syaryo, index, cloneSyaryos) {
      let failure = syaryo.SYARYO_TYPE_KBN === undefined
      if (!failure) {
        // 全く同じデータが既に存在するかチェック。存在する場合は不正データなのでエラーとする
        for (const i in cloneSyaryos) {
          if (index <= i) break

          const syaryo2 = cloneSyaryos[i]
          let isDiff = false
          for (const key in syaryo2) {
            if (syaryo[key] === '') syaryo[key] = null
            if (syaryo2[key] === '') syaryo2[key] = null
            if (syaryo2[key] !== syaryo[key]) {
              isDiff = true
              break
            }
          }
          if (!isDiff) {
            failure = true
            break
          }
        }
      }

      if (failure) {
        Store.dispatch('util/logging', {
          title: 'IS_FAILURE_SYARYO',
          subTitle: 'jyuchu-add-confirm',
          message: 'Exception:車両データエラー',
          type: 'error',
          data: this.clonedForm,
        })
      }

      return false
    },

    /** オプションデータを取得する */
    async getOption() {
      await this.$store.dispatch('mitumori/option').then((res) => {
        this.optionList = res
      })
    },

    inquire() {
      this.inquiry = {
        jyuchuSyaryoId: this.form.syaryos[0].ID,
        hikitoriYoteiBi: this.form.HANSYUTU_KIBOU_BI,
        isShowing: true,
      }
    },
  },

  computed: {
    /** 引取オークション表示フラグ */
    isHikitoriAA() {
      return !this.isLease && Number(this.form.HIKITORI_AA_FLG)
    },

    /** 納車オークション表示フラグ */
    isNosyaAA() {
      return !this.isLease && Number(this.form.NOSYA_AA_FLG)
    },

    /** 名変か判定する */
    isMeihen() {
      return this.form.MEIHEN_FLG
    },

    /** 納車希望日が土曜日か判定する */
    isNosyaSaturday() {
      return this.isWeekDay(this.form.HANNYU_KIBOU_BI, '土')
    },

    /** 請求可能な取引先か */
    isEnableInvoice() {
      return this.torihikiSaki.NAVI_SEIKYU_FLG
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
  td
    width: 68%
.order-sticky-scroll
  padding: 20px 0
  .order-sticky
    @extend .sticky
    padding: 4%
    top: 10px
    width: 100%
    height: 40px
    background: rgba(255,239,213,0.4)
    @include sp
      height: 70px
section.apply-consent
  margin: 20px auto
  background: $baseGrayColor
  border: 5px solid $baseBlueColor
  .check-box-wrapper
    margin-left: 20%
.md-dialog
  border: 5px solid $baseRedColor !important
  width: auto
</style>



// WEBPACK FOOTER //
// src/components/order/Confirm.vue